<template>
	<blockquote class="blockquote sanity-rich-text-component">
		<RichTextComponent :blocks="props.value.quote" />
		<cite
			v-if="source"
			class="blockquote-attribution body-sm text-color-content-tertiary"
			data-test="attribution"
			>{{ source }}</cite
		>
	</blockquote>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { PortableTextComponentProps } from '@portabletext/vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { SanityRichTextQuote } from 'types/sanity';

type Props = PortableTextComponentProps<SanityRichTextQuote>;

const props = defineProps<Props>();

const source = computed((): string => {
	return props.value.author ? `- ${props.value.author}` : '';
});
</script>
